import React, { PureComponent } from "react";

import SubGridCell from "./SubGridCell";
import TrackerCell from "./TrackerCell";
import { buildOrderedColumns } from "./columnOrder";

/**
 * One row in a Task/User sub-grid: native cells (by column descriptor) + the
 * resource's custom tracker columns, rendered in the (free) column order. The
 * first native column (anchor) is sticky and always rendered first; the rest are
 * reorderable. Reuses TrackerCell for custom columns.
 *
 * Handlers (stable, explicit-id):
 *   onNativeChange(recordId, field, value)
 *   onCustomChange(recordId, fieldId, value)
 */
class ResourceRow extends PureComponent {
	onNative = (field, value) => {
		this.props.onNativeChange(this.props.row.record_id, field, value);
	};

	onCustom = (fieldId, value) => {
		this.props.onCustomChange(this.props.row.record_id, fieldId, value);
	};

	_nativeValue(col) {
		const native = this.props.row.native || {};
		return native[col.key];
	}

	renderNativeCell(col) {
		const { roles, clientLabels, isAdmin } = this.props;
		const basis = "var(--etw-n_" + col.key + ", " + col.width + "px)";
		return (
			<div
				className={"et-grid__td " + (col.anchor ? "et-grid__td--anchor et-grid__td--sub-anchor" : "et-grid__td--native")}
				key={"nc-" + col.key}
				style={{ flex: "0 0 " + basis, width: basis }}
			>
				<SubGridCell
					type={col.type}
					value={this._nativeValue(col)}
					readonly={col.readonly}
					roles={roles}
					clientLabels={clientLabels}
					isAdmin={isAdmin}
					onChange={val => this.onNative(col.key, val)}
				/>
			</div>
		);
	}

	renderCustomCell(f) {
		const { row, fieldsById, datasourceLabels, engagementId } = this.props;
		let parentValue = null;
		let parentEntityKey = null;
		if (f.datasource && f.datasource.parentFieldId && fieldsById) {
			const parentField = fieldsById[f.datasource.parentFieldId];
			parentEntityKey = parentField && parentField.datasource ? parentField.datasource.entity : null;
			parentValue = parentEntityKey === "engagement" ? engagementId : (row.values || {})[f.datasource.parentFieldId];
		}
		const basis = "var(--etw-f_" + f.id + ", 220px)";
		return (
			<div className="et-grid__td" key={"fc-" + f.id} style={{ flex: "0 0 " + basis, width: basis }}>
				<TrackerCell
					field={f}
					value={(row.values || {})[f.id]}
					parentValue={parentValue}
					parentEntityKey={parentEntityKey}
					datasourceLabels={datasourceLabels ? datasourceLabels[f.id] : null}
					engagementId={engagementId}
					onChange={val => this.onCustom(f.id, val)}
				/>
			</div>
		);
	}

	render() {
		const { row, nativeColumns, fields, columnOrder, hiddenColumns } = this.props;
		const hidden = hiddenColumns || [];
		const anchorCol = (nativeColumns || []).find(c => c.anchor);
		const nonAnchorNative = (nativeColumns || []).filter(c => !c.anchor);
		const ordered = buildOrderedColumns(nonAnchorNative, fields, columnOrder).filter(
			d => hidden.indexOf(d.colKey) === -1,
		);

		return (
			<div className="et-grid__row et-grid__row--sub" data-row-key={"r-" + row.record_id}>
				{anchorCol && this.renderNativeCell(anchorCol)}
				{ordered.map(d => (d.kind === "native" ? this.renderNativeCell(d.col) : this.renderCustomCell(d.field)))}
			</div>
		);
	}
}

export default ResourceRow;
